import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'The following questions are to review how your progress has been so far. Please answer honestly and with as much detail as possible!',
    field: 'wl6months',
    type: 'info',
    answer: {}
  },
  {
    label: 'What is your current weight? (In Pounds)',
    type: 'info',
    field: 'wl6monthsWeightNow',
    placeholder: '',
    answer: {
      type: 'number',
      required: true,
      name: 'wl6monthsWeightNowAns'
    }
  },
  {
    label: 'How much weight have you lost? (In Pounds)',
    type: 'info',
    field: 'wl6monthsWeightLoss',
    answer: {
      type: 'number',
      name: 'wl6monthsWeightLossLb'
    }
  },
  {
    field: 'wl6monthsIsBowelMovementsIssue',
    label: 'Any issues with bowel movements?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl6monthsIsBowelMovementsIssueYes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl6monthsIsBowelMovementsIssueYesDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'wl6monthsIsBowelMovementsIssueNo', value: 'No' }
      ]
    }
  },
  {
    field: 'wl6monthsIsEatingConsistentlyAndDrinkingFluids',
    label:
      'Are you eating consistently throughout the day and drinking fluids?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl6monthsIsEatingConsistentlyAndDrinkingFluidsYes',
          value: 'Yes'
        },
        {
          key: 'wl6monthsIsEatingConsistentlyAndDrinkingFluidsNo',
          value: 'No',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl6monthsIsEatingConsistentlyAndDrinkingFluidsNoDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    field: 'wl6monthsEatingHabits',
    label:
      'Which of the following applies to your current eating habits?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl6monthsCreatureOfHabit',
          value: 'I am a creature of habit; I like to eat the same things every day.'
        },
        {
          key: 'wl6monthsVariety',
          value: 'I love to get variety and often eat a variety of different foods throughout the week.'
        
        },
        {
          key: 'wl6monthsStruggling',
          value: 'I am currently struggling to eat enough variety due to food aversions.'
        
        },
        {
          key: 'wl6monthsFewMeals',
          value: 'I have a few meals that I like to have the same foods for, but I have at least one meal a day where I get a variety of different foods.'
        
        }
      ]
    }
  },
  {
    field: 'wl6monthsSupplments',
    label: 'Have you had any updates to the supplements you are currently taking? If so, please list your new supplements.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl6monthsSuppsYes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl6monthsSuppsYesDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'wl6monthsSuppsNo', value: 'No' }
      ]
    }
  },
  {
    field: 'wl6monthsIsMedicalHealthChange',
    label: 'Have you had any changes to your health status or medication list?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wl6monthsIsMedicalHealthChangeYes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'wl6monthsIsMedicalHealthChangeYesDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'wl6monthsIsMedicalHealthChangeNo', value: 'No' }
      ]
    }
  }
];

export default questionsModels;
